import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const JobFairs = () => {
  const [jobFairs] = useState([
    {
      id: 1,
      slug: "faridabad",
      title: "Delhi NCR Job Fair – Faridabad",
      date: "4th  October 2025",
      image: "/images/jobfair.jpg",
      description:
        "The Job Fair held in Faridabad on 4th October 2025 was a great success. Hundreds of job seekers met top employers across multiple domains including IT, Sales, and Marketing.",
    },
    {
      id: 2,
      slug: "faridabad2",
      title: " Delhi NCR Job Fair – Faridabad",
      date: "8th November 2025",
      image: "/images/jflogo2.jpg",
      description:
               "Our Job Fair in Faridabad on 8th November 2025 was a huge success! It witnessed strong participation from job seekers and employers across multiple industries, including IT, Sales, and Marketing. ",
    },
    {
      id: 3,
      slug: "faridabad3",
      title: " Delhi NCR Job Fair – Faridabad",
      date: " Comming Soon",
      image: "/images/jflogo2.jpg",
      description:
               "comming soon",
    }
  ]);

  const sortedFairs = [...jobFairs].reverse();

  return (
    <>
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 py-12 bg-gray-50">
        <h1 className="text-center text-3xl font-bold text-red-600 mb-10">
          Our Job Fairs
        </h1>

        <div className="flex flex-col gap-10">
          {sortedFairs.map((fair) => (
            <Link
              to={`/jobfairs/${fair.slug}`}
              key={fair.id}
              className="flex flex-col md:flex-row bg-white rounded-2xl shadow-md hover:shadow-lg transition-transform hover:-translate-y-1 overflow-hidden no-underline"
            >
              <img
                src={fair.image}
                alt={fair.title}
                className="md:w-1/2 w-full h-64 object-cover"
              />
              <div className="p-6 md:w-1/2 flex flex-col justify-center text-center md:text-left">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  {fair.title}
                </h2>
                <p className="text-red-600 font-medium mb-3">{fair.date}</p>
                <p className="text-gray-600 leading-relaxed">
                  {fair.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default JobFairs;
